module.exports = __webpack_public_path__ + "img/appAsset-brand--axteroid-icon.c68b4004.svg";